import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';
import { CategoryItemType } from './getCategories';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const getCategoryByUri = async (
  uri: string,
  httpClient: HttpClientFactory,
): Promise<CategoryItemType> => {
  try {
    const response = await httpClient
      .getInstance()
      .get(`${clientTopology.categoriesUrl}/uri/${encodeURIComponent(uri)}?locale=${locale}`);
    return response.data;
  } catch (error) {
    logger.log({
      message: 'failed to fetch get all categories',
      error,
    });
    console.error(error);
    throw error;
  }
};
